import React from 'react';
import clsx from 'clsx';
import { Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, type DialogProps } from '@mui/material';

import usePopState from '../hooks/usePopState';
import useMountEffect from '../hooks/useMountEffect';

type ResponsiveDialogProps = {
	classes?: {
		root?: string;
		title?: string;
		headerAction?: string;
		content?: string;
		actions?: string;
	};
	title?: React.ReactNode;
	headerAction?: React.ReactNode;
	content?: React.ReactNode;
	actions?: React.ReactNode;
	disablePadding?: boolean;
	dividers?: boolean;
	onClose?: VoidFunction;
} & Omit<DialogProps, 'classes' | 'title' | 'content' | 'onClose'>;

export default function ResponsiveDialog({
	open,
	onClose,
	classes,
	maxWidth = 'xl',
	fullWidth = true,
	title,
	headerAction,
	content,
	actions,
	children,
	disablePadding,
	dividers,
	...otherProps
}: ResponsiveDialogProps) {
	const isMaxWidth = useMediaQuery(theme => theme.breakpoints.only(maxWidth || 'sm'));
	const belowMaxWidth = useMediaQuery(theme => theme.breakpoints.down(maxWidth || 'sm'));
	const fullScreen = (isMaxWidth || belowMaxWidth) && maxWidth !== 'xs';

	usePopState(onClose);

	// useMountEffect(() => {
	// 	return () => {
	// 		onClose?.();
	// 	};
	// });

	return (
		<Dialog
			open={open}
			onClose={(_event, reason) => {
				if (reason === 'escapeKeyDown') {
					onClose?.();
				}
			}}
			classes={{
				root: classes?.root,
				paper: !belowMaxWidth ? 'rounded-8' : 'rounded-none'
			}}
			maxWidth={maxWidth}
			fullWidth={fullWidth}
			fullScreen={maxWidth ? belowMaxWidth : false}
			{...otherProps}
		>
			{open &&
				(children || (
					<>
						{title && <DialogTitle className={classes?.title}>{title}</DialogTitle>}
						{headerAction && <div className="absolute right-8 top-8">{headerAction}</div>}
						{content && (
							<DialogContent
								className={clsx(classes?.content, disablePadding ? 'p-0' : '')}
								dividers={dividers}
							>
								{content}
							</DialogContent>
						)}
						{actions && <DialogActions className={classes?.actions}>{actions}</DialogActions>}
					</>
				))}
		</Dialog>
	);
}
